import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delivery-popup',
  templateUrl: './delivery-popup.component.html',
  styleUrls: ['./delivery-popup.component.css']
})
export class DeliveryPopupComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
